import React from "react";
import "./Collaborators.css";

import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Link } from "@mui/material";
import { collaboratorsData } from "./collaboratorsData";

const Collaborators = () => {
  return (
    <>
      <div className="my-2">
        <Grid container spacing={2}>
          {/* Display the first collaborator always */}
          <Grid item xs={12} md={6}>
            <div className="d-flex flex-row gap-2 align-items-center">
              <Avatar src="" alt="" sx={{ width: 37, height: 37 }} />
              <div>
                <p className="collaborator_name archivo m-0">
                  Written By:{" "}
                  <span className="archivo">
                    <Link underline="hover" sx={{ cursor: "pointer" }}>
                      {collaboratorsData[0].writtenBy}
                    </Link>
                  </span>
                </p>
                <p className="author_position d-flex flex-row align-items-center archivo m-0 fw-light">
                  {collaboratorsData[0].writterPosition}&nbsp;
                  <img
                    src="/Assets/Images/information.webp"
                    alt="info"
                    style={{ width: 11, height: 11 }}
                  />
                </p>
              </div>
            </div>
          </Grid>

          {/* Display the second collaborator based on screen size */}
          <Grid item xs={12} md={6}>
            <div className="d-flex flex-row gap-2 align-items-start">
              <Avatar src="" alt="" sx={{ width: 37, height: 37 }} />
              <div>
                <p className="collaborator_name archivo m-0">
                  Edited by{" "}
                  <span className="archivo">
                    <Link underline="hover" sx={{ cursor: "pointer" }}>
                      {collaboratorsData[1].editedBy}
                    </Link>
                  </span>
                </p>
                <p className="author_position d-flex flex-row archivo m-0 fw-light">
                  {collaboratorsData[1].editorPosition}&nbsp;
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    style={{ fontSize: 12 }}
                  />
                </p>
                <div
                  style={{
                    width: "6.7rem",
                    textDecoration: "none",
                    border: "1px solid #005FB9",
                    borderRadius: "25px",
                    color: "#005FB9",
                    fontSize: 12,
                    fontWeight: 600,
                    padding: "0px 6px",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                  className="d-flex flex-row gap-1 align-items-center mt-1"
                >
                  <img
                    src="/Assets/Images/bluetick.png"
                    alt="bluetick"
                    style={{ width: 12, height: 12 }}
                  />
                  <p className="m-0">Fact Checked</p>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Collaborators;
